<h1 mat-dialog-title>Vorschau</h1>

<div mat-dialog-content>
    <h3>Beispiel-Datensatz</h3>
    <div class="one-row">
        <div class="one-column" *ngIf="artikel.bezeichnung">
            <h3>Bezeichnung</h3>
            <div>{{ artikel.bezeichnung }}</div>
        </div>
        <div class="one-column" *ngIf="artikel.einzelpreis">
            <h3>Preis</h3>
            <div>{{ artikel.einzelpreis }}</div>
        </div>
        <div class="one-column" *ngIf="artikel.ust">
            <h3>Mehrwehrtsteuer</h3>
            <div>{{ artikel.ust }}</div>
        </div>
        <div class="one-column" *ngIf="artikel.kuerzel">
            <h3>Kuerzel</h3>
            <div>{{ artikel.kuerzel }}</div>
        </div>
        <div class="one-column" *ngIf="artikel.faktor">
            <h3>Faktor</h3>
            <div>{{ artikel.faktor }}</div>
        </div>
        <div class="one-column" *ngIf="artikel.warengruppe">
            <h3>Warengruppe</h3>
            <div>{{ artikel.warengruppe }}</div>
        </div>
    </div>
</div>
<div align="end" mat-dialog-actions>
    <button (click)="dialogRef.close()" mat-button>Abbrechen</button>
    <button *kienePermission="[1234]" (click)="dialogRef.close(true)" color="primary" mat-flat-button>
        Hochladen
    </button>
</div>
